import type { EditorActiveTab } from "./tauri/core";
import { pushProjectPath } from "./projectRouter";
import { DEFAULT_SECTION_ROUTES } from "../router/projectPaths";
import { useEditorNavStore, type NavSection } from "../stores/useEditorNavStore";

function tabToSection(tab: EditorActiveTab): NavSection {
  return tab;
}

/**
 * Navigate to a section, preferring the sticky last route for that section.
 * Persistence of lastRoute is handled by route sync (desktop only) — not here.
 */
export async function navigateToProjectTab(tab: EditorActiveTab): Promise<void> {
  const nav = useEditorNavStore();
  const path =
    nav.routeForSection(tabToSection(tab)) ?? DEFAULT_SECTION_ROUTES[tab];
  await pushProjectPath(path);
}
